module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/vertical-pill-style1/vertical-pill-style1.component.scss
// module id = ./src/app/features/tabination/vertical-pill-style1/vertical-pill-style1.component.scss
// module chunks = main